import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2 } from "lucide-react";
import { API } from "@/lib/constants";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ loading: true, paid: false, booking: null });

  useEffect(() => {
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setState({ loading: false, paid: true, booking: res.data.booking });
          return;
        }
      } catch (e) { /* keep polling briefly */ }
      attempts += 1;
      if (attempts < 10) timer = setTimeout(poll, 2000);
      else setState({ loading: false, paid: false, booking: null });
    };
    if (sessionId) poll();
    else setState({ loading: false, paid: false, booking: null });
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <main className="min-h-screen bg-[#EBEBFA] flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="bg-white rounded-3xl shadow-sm p-10 md:p-14 max-w-lg w-full text-center">
        {state.loading ? (
          <>
            <Loader2 className="w-10 h-10 animate-spin mx-auto text-[#1A243B] mb-4" />
            <h1 className="font-display text-2xl text-[#1A243B]" data-testid="success-loading">Confirming your payment…</h1>
          </>
        ) : state.paid ? (
          <>
            <span className="w-16 h-16 rounded-full bg-[#FFC107] flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-8 h-8 text-[#1A243B]" />
            </span>
            <h1 className="font-display text-3xl text-[#1A243B] mb-3" data-testid="success-heading">Booking confirmed</h1>
            <p className="text-[#2D3748] text-base leading-relaxed mb-2" data-testid="success-detail">
              {state.booking
                ? `${state.booking.service_name} on ${state.booking.date} — paid $${(state.booking.total_cents / 100).toFixed(2)}.`
                : "Your payment was received."}
            </p>
            <p className="text-[#2D3748] text-base leading-relaxed mb-8">
              A confirmation email is on its way to you, and Julie has been notified.
            </p>
            <Link to="/" data-testid="success-home-btn" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] font-bold px-8 py-3.5 rounded-full">
              Back to homepage
            </Link>
          </>
        ) : (
          <>
            <h1 className="font-display text-2xl text-[#1A243B] mb-3" data-testid="success-pending-heading">Payment not confirmed yet</h1>
            <p className="text-[#2D3748] text-base leading-relaxed mb-8">
              We couldn't confirm your payment. If you completed checkout, it may take a moment — otherwise please try booking again or call 503-449-8323.
            </p>
            <Link to="/" data-testid="success-home-btn" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] font-bold px-8 py-3.5 rounded-full">
              Back to homepage
            </Link>
          </>
        )}
      </div>
    </main>
  );
}
